import { FC } from 'react';
import { SidebarBase } from '../common';
import { useSidebarItems } from '../common/hooks';

type SidebarNavigationProps = {
  className?: string;
};

export const SidebarNavigation: FC<SidebarNavigationProps> = ({ className }) => {
  const items = useSidebarItems();

  return (
    <SidebarBase.Navigation className={className}>
      <div className='grow'>
        {items.map((item) => (
          <SidebarBase.NavItem
            key={item.path}
            {...item}
            classNames={{
              text: 'text-secondary-700',
            }}
          />
        ))}
      </div>
    </SidebarBase.Navigation>
  );
};
